import { render, staticRenderFns } from "./ROITableMail.vue?vue&type=template&id=068ac8d6&scoped=true&"
import script from "./ROITableMail.vue?vue&type=script&lang=js&"
export * from "./ROITableMail.vue?vue&type=script&lang=js&"
import style0 from "./ROITableMail.vue?vue&type=style&index=0&id=068ac8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ac8d6",
  null
  
)

export default component.exports